import Content from "../../help/lots.mdx";

export function LotsHelpPage() {
  return <Content />;
}
